import React, { useState } from 'react';
import ColorsMain from "../../colors/ColorsMain.js";
import HIDE from "../../assets/IconsColurs/IconsGeneral/hide.svg";
import SHOW from "../../assets/IconsColurs/IconsGeneral/show.svg";

const InputLogin = ({
    mt = "0px",
    label = "",
    placeholder = "",
    password = false,
    onChange = () => { },
    value,
    error = false,
    LoginRequest = () => { },
    readOnly = false,
    maxLength,
    numericOnly = false,
    formatValue = () => value, // Función de formato opcional
}) => {
    const [show, setShow] = useState(false);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && password) {
            LoginRequest();
        }
    };

    const handleChange = (e) => {
        let inputValue = e.target.value;
        if (numericOnly) {
            // Quitar caracteres no numéricos
            inputValue = inputValue.replace(/[^0-9]/g, '');
        }
        onChange(inputValue); // Guardar solo números
    };

    return (
        <div
            className={`flex justify-between items-center py-2 pr-3 pl-2 text-base border rounded flex-row w-full transition-colors duration-300 ease-in-out mt-[${mt}]`}
            style={{
                backgroundColor: ColorsMain.bgInput,
                borderColor: error ? ColorsMain.errorBorder : ColorsMain.borderInput,
                color: ColorsMain.texttMain,
            }}
        >
            <input
                style={{ backgroundColor: ColorsMain.bgInput, color: ColorsMain.texttMain }}
                className="w-full"
                onKeyDown={handleKeyDown}
                readOnly={readOnly}
                autoComplete="current-password"
                type={password ? (show ? "text" : "password") : "text"}
                placeholder={placeholder}
                value={value ? formatValue(value) : value} // Aplicar formato solo si hay valor
                onChange={handleChange}
                maxLength={maxLength}
            />
            {password && show && (
                <img
                    className="ml-2"
                    onClick={() => setShow(false)}
                    src={HIDE}
                    style={{ width: 20, height: 20 }}
                    alt="Hide Password"
                />
            )}
            {password && !show && (
                <img
                    className="ml-2"
                    onClick={() => setShow(true)}
                    src={SHOW}
                    style={{ width: 20, height: 20 }}
                    alt="Show Password"
                />
            )}
        </div>
    );
};

export default InputLogin;
